export const getDocumentType = (id: number) => {
    switch (id) {
        case 1:
            return 'DNI';
        case 2:
            return 'RUC';
        case 3:
            return 'CE';
        case 9:
            return 'PAS';
        default:
            return 'Unknown';
    }
};
export const getGender = (code: string) => {
    switch (code) {
        case 'F':
            return 'Femenino';
        case 'M':
            return 'Masculino';
        default:
            return 'Unknown';
    }
};

export const getParameter = (data: any, key: string) => {
    const parameter = data.find((item: any) => item.parametro === key);
    return parameter?.valor;
}
export const formatDate01 = (dateString: string): string => {
    //toma string con fecha, hora y muestra solo fecha
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
}

export const formatDate02 = (fecha: string): string => {
    //convierte fecha dd/MM/yy a dd/MM/yyyy
    const regex = /^(\d{2})\/(\d{2})\/(\d{2})$/;
    const match = fecha.match(regex);
  
    if (match) {
      const dia = match[1];
      const mes = match[2];
      let anio = match[3];
  
      if (anio.length === 2) {
        anio = parseInt(anio) >= 50 ? '19' + anio : '20' + anio;
      }
      return `${dia}/${mes}/${anio}`;
    }
  
    return 'Formato de fecha inválido';
};

export const formatDate03 = (date: string): string => {
    const parsedDate = new Date(date);
    
    // Asegurarse de que la fecha esté en el formato adecuado
    const year = parsedDate.getFullYear();
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Mes debe tener dos dígitos
    const day = parsedDate.getDate().toString().padStart(2, '0'); // Día debe tener dos dígitos
 
    return `${year}-${month}-${day}`;
};

export const formatDate04 = (fecha: string): string => {
    //convierte fecha dd/MM/yy a dd/MM/yyyy
    const regex = /^(\d{2})\/(\d{2})\/(\d{2})$/;
    const match = fecha.match(regex);
  
    if (match) {
      const dia = match[1];
      const mes = match[2];
      let anio = match[3];
  
      if (anio.length === 2) {
        anio = parseInt(anio) >= 50 ? '19' + anio : '20' + anio;
      }
      return `${anio}-${mes}-${dia}`;
    }
  
    return 'Formato de fecha inválido';
};

export const formatDate05 = (fecha: string): string => {
    const match = fecha.split('/');
  
    if (match) {
      const dia = match[0];
      const mes = match[1];
      const anio = match[2];
      return `${anio}-${mes}-${dia}`;
    }
  
    return 'Formato de fecha inválido';
};

/* obtener descricion del mes por numero de mes del 1 al 12*/
export const getMonthDescription = (month: number) => {
    switch (month) {
        case 1:
            return 'Enero';
        case 2:
            return 'Febrero';
        case 3:
            return 'Marzo';
        case 4:
            return 'Abril';
        case 5:
            return 'Mayo';
        case 6:
            return 'Junio';
        case 7:
            return 'Julio';
        case 8:
            return 'Agosto';
        case 9:
            return 'Septiembre';
        case 10:
            return 'Octubre';
        case 11:
            return 'Noviembre';
        case 12:
            return 'Diciembre';
        default:
            return '-';
    }
}

export const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};